var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/system/Box';
import { Typography } from '../Typography';
import { getCouponClipboardStyles } from './CouponClipboard.style';
import { colorPalette } from '../../colorPalette';
import CopyAll from '@mui/icons-material/CopyAll';
import Check from '@mui/icons-material/Check';
import { CurrencyFormatter } from '../CurrencyFormatter';
export const CouponClipboard = ({ format = 'block', couponValue, primaryText, fromValue, secondaryText, couponCode, tooltipTitle = 'Code copié !', boxWrapperSX, }) => {
    const styles = getCouponClipboardStyles(format, fromValue);
    const [openTooltip, setOpenTooltip] = useState(false);
    const handleClick = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield navigator.clipboard.writeText(couponCode);
            setOpenTooltip(true);
            setTimeout(() => {
                setOpenTooltip(false);
            }, 3000);
        }
        catch (error) {
            setOpenTooltip(false);
        }
    });
    return (React.createElement(Box, { sx: Object.assign(Object.assign({}, styles.boxWrapper), boxWrapperSX) },
        React.createElement(Tooltip, { arrow: true, placement: format === 'line' ? 'bottom' : 'bottom-start', title: React.createElement(Typography, { "data-qa": "tooltip", variant: "body-small-regular", sx: { flex: '1 0 0' } }, tooltipTitle), slotProps: {
                popper: {
                    disablePortal: true,
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, -9],
                            },
                        },
                    ],
                    sx: styles.tooltip,
                },
                arrow: {
                    sx: {
                        color: colorPalette.gray900,
                        transform: 'translate3d(0px, 0px, 0px) !important',
                        left: `calc(50% - 5.5px) !important`,
                    },
                },
            }, open: openTooltip },
            React.createElement(Stack, { "data-qa": "couponClipboard", component: 'button', onClick: handleClick, direction: format === 'line' ? 'row' : 'column', alignItems: format === 'line' ? 'center' : 'stretch', justifyContent: format === 'line' ? 'space-between' : 'flex-start', sx: styles.wrapper },
                React.createElement(Stack, { direction: format === 'line' ? 'row' : 'column', flexWrap: format === 'line' ? 'wrap' : 'nowrap', justifyContent: 'flex-start', spacing: format === 'line' ? '4px' : '0px', alignSelf: 'stretch', sx: styles.container },
                    React.createElement(Stack, { direction: 'row', justifyContent: 'space-between', alignItems: 'center', alignSelf: 'stretch' },
                        React.createElement(Stack, { "data-qa": "firstLineText", direction: 'row', spacing: '4px', flex: '1 0 0', color: colorPalette.gray900, overflow: 'hidden' },
                            couponValue && (React.createElement(Typography, { variant: "body-default-semibold" },
                                '-',
                                React.createElement(CurrencyFormatter, { amount: couponValue }))),
                            primaryText && (React.createElement(Typography, { variant: "body-default-regular", noWrap: secondaryText ? false : true }, primaryText)),
                            fromValue && (React.createElement(Typography, { variant: "body-default-semibold", noWrap: true }, fromValue))),
                        format === 'block' &&
                            (!openTooltip ? React.createElement(CopyAll, { "data-qa": "iconBlock", sx: styles.icons }) : React.createElement(Check, { "data-qa": "checkIcon", sx: styles.icons }))),
                    secondaryText && (React.createElement(Typography, { "data-qa": "secondaryText", variant: "body-default-regular", color: colorPalette.gray900 }, secondaryText)),
                    couponCode && (React.createElement(Typography, { "data-qa": "couponCode", variant: "body-default-semibold", color: colorPalette.red800 }, couponCode))),
                format === 'line' &&
                    (!openTooltip ? React.createElement(CopyAll, { "data-qa": "iconLine", sx: styles.icons }) : React.createElement(Check, { "data-qa": "checkIcon", sx: styles.icons }))))));
};
